import IonqLogo from '@assets/ionq-logo.svg?react';
import { Box, Button, Center } from '@chakra-ui/react';
import { useChunkErrorAutoReload } from '@ionq/app-update';
import { ErrorScreen, Loading } from '@ionq/legacy-ui';
import { useRouteError } from 'react-router';

// Route errorElement: at the root it renders in place of AppLayout and owns
// the viewport; nested boundaries (the jobs branch) size to their pane via
// `height` and name their scope via `title`.
export default function RouteErrorFallback({
    title = 'This page could not be loaded.',
    height = '100dvh',
}: {
    title?: string;
    height?: string;
}) {
    const error = useRouteError();
    // A deploy rotated the hashed chunks (the shell's or the remote's — old
    // remote chunks 404 no-store after a cloud-ui deploy): a guarded reload
    // is in flight onto the committed target URL, so show progress instead
    // of an error for the moment before it lands.
    const reloading = useChunkErrorAutoReload(error);

    if (reloading) {
        return (
            <Box height={height}>
                <Loading />
            </Box>
        );
    }

    return (
        <Center height={height} width='100%' overflow='auto'>
            <ErrorScreen
                logo={IonqLogo}
                statusCode={500}
                title={title}
                message={error instanceof Error ? error.message : undefined}
            >
                <ErrorScreen.Actions>
                    <Button
                        variant='solid'
                        onClick={() => window.location.reload()}
                    >
                        Refresh
                    </Button>
                </ErrorScreen.Actions>
            </ErrorScreen>
        </Center>
    );
}
